// wrapped in .icon so the global button:hover padding for text buttons leaves it alone
const soundIcons = `
    <svg class="videoControls__soundOn" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M16.5 12a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4zM14 3.2v2.1a7 7 0 0 1 0 13.4v2.1a9 9 0 0 0 0-17.6z"/></svg>
    <svg class="videoControls__soundOff" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M16 9.4 17.4 8l2.1 2.1L21.6 8 23 9.4l-2.1 2.1 2.1 2.1-1.4 1.4-2.1-2.1-2.1 2.1-1.4-1.4 2.1-2.1z"/></svg>`;

function addButtons(wrapper) {
    const tc = window.GLOBALS?.tc ?? {};
    const buttons = document.createElement('div');
    buttons.className = 'videoControls__buttons';
    buttons.innerHTML = `
        <button type="button" class="btnNoStyle videoControls__btn videoControls__play" aria-pressed="false"><i class="icon icon-play"></i></button>
        <button type="button" class="btnNoStyle videoControls__btn videoControls__mute" aria-pressed="true"><span class="icon">${soundIcons}</span></button>`;
    buttons.querySelector('.videoControls__play').setAttribute('aria-label', tc.video_play || 'Video abspielen');
    buttons.querySelector('.videoControls__mute').setAttribute('aria-label', tc.video_mute || 'Ton aus- und einschalten');
    wrapper.append(buttons);
}

export function initVideoControls() {
    for (const wrapper of document.querySelectorAll('.videoControls')) {
        const video = wrapper.querySelector('video');

        if (!video) {
            continue;
        }

        if (!wrapper.querySelector('.videoControls__buttons')) {
            addButtons(wrapper);
        }

        const playButton = wrapper.querySelector('.videoControls__play');
        const muteButton = wrapper.querySelector('.videoControls__mute');

        const setMuted = (muted) => {
            video.muted = muted;
            wrapper.classList.toggle('is-muted', muted);
            muteButton.setAttribute('aria-pressed', String(muted));
        };

        setMuted(true);
        // an autoplaying video is already running, so it skips the teaser and starts with the small buttons
        wrapper.classList.toggle('is-active', video.autoplay);
        wrapper.classList.toggle('is-playing', video.autoplay || !video.paused);
        playButton.setAttribute('aria-pressed', String(video.autoplay || !video.paused));
        video.addEventListener('play', () => wrapper.classList.add('is-playing'));
        video.addEventListener('pause', () => wrapper.classList.remove('is-playing'));

        playButton.addEventListener('click', () => {
            // first click leaves the muted teaser loop and starts the video from the beginning with sound
            if (!wrapper.classList.contains('is-active')) {
                wrapper.classList.add('is-active');
                video.currentTime = 0;
                setMuted(false);
                video.play();
            } else if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
            playButton.setAttribute('aria-pressed', String(!video.paused));
        });

        muteButton.addEventListener('click', () => setMuted(!video.muted));
    }
}
